const buildQuery = (query) => {
  if (!query) return '';
  const searchParameter = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach((value) => searchParameter.append(k, String(value)));
    else searchParameter.append(k, String(v));
  });
  const parameterToString = searchParameter.toString();
  return parameterToString ? `?${parameterToString}` : '';
};

export const wpFetch = async (path, { method = 'GET', query, body, headers, signal } = {}) => {
  const segments = Array.isArray(path) ? path : [path];
  const pathValue = segments.map(String).join('/');

  const queryWithPath = { ...(query || {}), path: pathValue };
  const queryString = buildQuery(queryWithPath);

  const url = `/api/wp${queryString}`;

  const response = await fetch(url, {
    method,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
    body: method === 'GET' || method === 'HEAD' ? undefined : JSON.stringify(body ?? {}),
    signal,
  });

  const ct = response.headers.get('content-type') || '';
  const isJSON = ct.includes('application/json');
  const payload = isJSON ? await response.json() : await response.text();

  if (!response.ok) {
    const errorMessage = isJSON && payload?.message ? payload.message : payload || 'Request failed';
    throw new Error(errorMessage);
  }
  return payload;
};
